import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Table, Alert } from 'antd'
import { getDataOfType } from 'src/lib/utils/get-data-of-type'
import B2BLayout from 'src/react-app/layouts/b2b'
import fetchAPI from 'src/lib/utils/fetch-api'
import FieldHideText from 'src/react-app/components/field-hide-text'
import { afterDataColumns, beforeDataColumns } from 'src/react-app/components/list-operations/consts'
import EditCard from 'src/react-app/components/list-operations/edit-card'
import { calcTotalWidth, tableRowClick, getColumnsOfSchema, fetchSchema, listColumnsHidden, formatListData } from 'src/lib/utils/list'
import { getStagesGroup } from 'src/react-app/pages/list-orders/utils'

const name = 'card-audit'

export default function AdminObjectsListPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const [dataSource, setDataSource] = useState<any[]>([])
  const [isDataLoading, setIsDataLoading] = useState(true)
  const [dataColumns, setDataColumns] = useState<any[]>([])
  const [pageErrors, setPageErrors] = useState<String[]>([])
  const breadcrumbs = useMemo(() => (
    [{
      href: location.pathname,
      title: 'Аудит',
    }, {
      href: location.pathname,
      title: 'Список аудитов',
    }]
  ), [location.pathname])
  const totalWidth: any = useMemo(() => calcTotalWidth(beforeDataColumns, dataColumns, afterDataColumns), [dataColumns])

  // @ts-ignore
  const finalColumns = useMemo(() => [].concat(beforeDataColumns, dataColumns, afterDataColumns).filter(item => item.title), [dataColumns])
  const cbTableRowClick = useCallback(({ id }) => navigate(`/audit/${id}/edit`), [history])

  useEffect(() => {
    const getData = async () => {
      const pageErrors: string[] = []
      const [selectedSchema, metadata, collections, stages] = await Promise.all([
        fetchSchema({ name }),
        fetchAPI(`/api/collections/${name}/metadata`),
        fetchAPI(`/api/collections-case/${name}?access_key=axioma`),
        getStagesGroup('audit')
      ])
      const columnsHidden = getDataOfType(metadata, 'data.columnsHidden', Array, [])
      const collectionsResultData = getDataOfType(collections, 'data.data', Array, [])
      const isMetadata = getDataOfType(metadata, 'data', Object, null)
      if(isMetadata === null) {
        pageErrors.push('Некорректный ответ сервера при получении метаданных коллекции')
      }
      const dataSource: any[] = formatListData(collectionsResultData, selectedSchema)
      const newDataSource = dataSource.map(item => ({
        ...item,
        deleteRecord,
        stages
      }))
      const preparedDataColumns: any[] = getColumnsOfSchema(selectedSchema)
      const datalistColumnsHidden = listColumnsHidden(preparedDataColumns, columnsHidden)
      const newDataColumns = datalistColumnsHidden.map(column => ({
          ...column,
          fixed: 'left',
          width: 120,
          render: (text, { id, schema }) => (
          <EditCard id={id} schema={schema} title="Редактирование">
           {FieldHideText({ text })}
          </EditCard>
        )}
      ))
      setDataColumns(newDataColumns)
      setDataSource(newDataSource)
      setPageErrors(pageErrors)
      setIsDataLoading(false)
    }

    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deleteRecord = useCallback(async (currentId) => {
    try{
      await fetchAPI(`/api/collections/objects/${currentId}`, { method: 'DELETE'})
      setDataSource(dataSource => dataSource.filter(({ id }) => id !== currentId))
    }catch(error){
      console.error(error)
    }
  },[])

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      {(pageErrors.length > 0) ? (
        <div style={{ marginBottom: 40 }}>
          <Alert
            message="При выполнении операции возникла ошибка:"
            showIcon
            type="error"
            description={pageErrors.join('. ')}
            />
        </div>
      ): null}
      <Table
        columns={finalColumns}
        size="small"
        dataSource={dataSource}
        scroll={{ x: totalWidth, y: '72vh' }}
        pagination={false}
        loading={isDataLoading}
        onHeaderRow={(column: any) => ({
          style: {
            fontSize: (column.key && column.key.substr(-3) === '-at') ? 9 : 13,
          }
        })}
        onRow={record => ({ onClick: event => tableRowClick(event, record, cbTableRowClick)})}
        />
    </B2BLayout>
  )
}
